import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Compare } from 'src/app/Modules/settings/core/Validators/compare.Validator';
import { MustValue } from 'src/app/Modules/settings/core/Validators/mustValue.validator';
import { SettingValueModel, UserSettingModel } from '../../../../models/informate';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { Router } from '@angular/router';
import { CustomToastService } from 'src/app/services/custom-toast.service';

export interface ComponentGroupModel {
    index: number;
    checked: boolean;
    visible: ComponentControlModel;
    text: ComponentControlModel;
    value: ComponentControlModel;
}

export interface ComponentControlModel {
    key: string;
    name: string;
}

@Component({
    selector: 'app-calculation-preferences-pass-pct',
    templateUrl: './calculation-preferences-pass-pct.component.html',
    styleUrls: ['./calculation-preferences-pass-pct.component.scss'],
    standalone: false
})
export class CalculationPreferencesPassPctComponent implements OnInit {
    @Input() form: UntypedFormGroup;
    @Input() passCount: number = 1;
    @Input()
    set dataSource(value: UserSettingModel[]) {
        if (value) {
            this._dataSource = value;
            this.managePassValues();
        }
    }
    get dataSource(): UserSettingModel[] {
        return this._dataSource;
    }

    passes: number[];
    passState: ComponentGroupModel[];
    isLeastSelected: boolean;
    lastSelectedPass: ComponentGroupModel;
    private _sectionPrefix = 'Calculation_Pass';
    private _dataSource: UserSettingModel[];

    constructor(
        private cd: ChangeDetectorRef,
        private user_utility: UserUtilityService,
        private customToastService: CustomToastService,
        public router: Router
    ) {
        this.isLeastSelected = false;
    }

    ngOnInit(): void {}

    managePassValues() {
        this.passes = Array(this.passCount)
            .fill(1)
            .map((x, i) => i + 1);
        this.passState = this.passes.map((pass, index): ComponentGroupModel => {
            return {
                index: pass,
                checked: this.getCheckedState(this.getControlData(pass, 'Visible').setting.key),
                visible: {
                    key: this.getControlData(pass, 'Visible').setting.key,
                    name: this.getControlData(pass, 'Visible').setting.name,
                },
                text: {
                    key: this.getControlData(pass, 'Text').setting.key,
                    name: this.getControlData(pass, 'Text').setting.name,
                },
                value: {
                    key: this.getControlData(pass, 'Value').setting.key,
                    name: this.getControlData(pass, 'Value').setting.name,
                },
            };
        });
        for (let x = 0; x < this.passState.length; x++) {
            if (this.passState[x].checked) {
                this.lastSelectedPass = this.passState[x];
            }
        }

        for (let x = 0; x < this.passState.length; x++) {
            if (this.passState[x].checked === true) {
                this.manageControls(this.passState[x], this.passState[x].checked);
            }
        }
    }

    ngAfterViewInit() {
        this.form?.valueChanges?.pipe(debounceTime(100), distinctUntilChanged()).subscribe((res) => {
            if (res) {
                // this.checkingValidators();
            }
        });
    }

    getControlData(pass: number, type: string): UserSettingModel {
        return this.dataSource.find((item) => item.setting.key.toLowerCase() === `${this._sectionPrefix}${pass}_${type}`.toLowerCase()) ?? null;
    }

    getCheckedState(key: string): boolean {
        const ctrlModel: UserSettingModel = this.dataSource.find((item) => item.setting.key.toLowerCase() === key.toLowerCase()) ?? null;

        if (!ctrlModel) return false;

        return ctrlModel.settingValue?.value.toLowerCase() === 'true';
    }

    textBoxChange(pass: ComponentGroupModel, event): void {
        const ctrlModel: UserSettingModel = this.dataSource.find((item) => item.setting.key === event.target.name) ?? null;

        if (!ctrlModel) return;

        if (ctrlModel.value !== event.target.value) {
            this.form.get(ctrlModel.setting.key).markAsDirty();
            this.form.get(ctrlModel.setting.key).markAsTouched();
        } else {
            this.form.get(ctrlModel.setting.key).markAsPristine();
        }
        this.checkingValidators();
    }

    checkboxChange(pass: ComponentGroupModel, event: MatCheckboxChange): void {
        // if checkBox is checked
        if (event.checked) {
            for (let x = 0; x < pass.index; x++) {
                if (pass.index === 4 && x < 3) {
                    continue;
                }
                const ctrlModel: UserSettingModel =
                    this.dataSource.find((item) => item.setting.key.toLowerCase() === this.passState[x].visible.key.toLowerCase()) ?? null;

                if (!ctrlModel) return;

                const selectedOption: SettingValueModel = ctrlModel.setting.settingValues.find(
                    (opt) => opt.value.toLowerCase() === String(event.checked).toLowerCase()
                );

                if (selectedOption) {
                    this.form.get(ctrlModel.setting.key).setValue(selectedOption.settingValueId);
                    if (ctrlModel.settingValue.settingValueId !== selectedOption.settingValueId) {
                        this.form.get(ctrlModel.setting.key).markAsDirty();
                        this.form.get(ctrlModel.setting.key).markAsTouched();
                    } else {
                        this.form.get(ctrlModel.setting.key).markAsPristine();
                    }
                }
            }
        } else {
            // checkbox is unchecked
            if (pass.index === 1) {
                this.isLeastSelected = true;
            }
            // for (let x = pass.index - 1; x < (pass.index === 4 ? this.passState.length : this.passState.length - 1); x++)
            for (let x = pass.index - 1; x < 4; x++) {
                const ctrlModel: UserSettingModel =
                    this.dataSource.find((item) => item.setting.key.toLowerCase() === this.passState[x].visible.key.toLowerCase()) ?? null;

                if (!ctrlModel) return;

                const selectedOption: SettingValueModel = ctrlModel.setting.settingValues.find(
                    (opt) => opt.value.toLowerCase() === String(event.checked).toLowerCase()
                );

                if (selectedOption) {
                    this.form.get(ctrlModel.setting.key).setValue(selectedOption.settingValueId);
                    if (ctrlModel.settingValue.settingValueId !== selectedOption.settingValueId) {
                        this.form.get(ctrlModel.setting.key).markAsDirty();
                        this.form.get(ctrlModel.setting.key).markAsTouched();
                    } else {
                        this.form.get(ctrlModel.setting.key).markAsPristine();
                    }
                }
            }
            this.removeValidators();
        }
        this.manageControls(pass, event.checked);
        this.toggleCheckBox(pass, event.checked);
        this.checkingValidators();

        this.user_utility.noneSelectedPassPct = this.passState.every((x) => !x.checked);
        if (this.user_utility.noneSelectedPassPct) {
            this.customToastService.infoToast('Atleast one pass must be selected!', 'Info');
            this.form.setErrors({ invalidForm: true });
        }
    }

    disableControl(i: number) {
        let ctrlModel = this.passState.find((item) => item.index === i);
        this.form.controls[ctrlModel.value.key].disable();
        this.form.controls[ctrlModel.text.key].disable();
    }

    enableControl(i: number) {
        let ctrlModel = this.passState.find((item) => item.index === i);
        this.form.controls[ctrlModel.value.key].enable();
        this.form.controls[ctrlModel.text.key].enable();
    }

    manageControls(pass: ComponentGroupModel, checked: boolean): Promise<any> {
        return new Promise<true>((resolve, reject) => {
            switch (pass.index) {
                case 1:
                    if (checked === true && pass.index === 1) {
                        pass.checked = checked;
                        this.enableControl(1);
                        this.disableControl(2);
                        this.disableControl(3);
                        this.disableControl(4);
                    } else {
                        this.enableControl(1);
                        this.disableControl(2);
                        this.disableControl(3);
                        this.disableControl(4);

                        }
                    break;
                case 2:
                    if (checked === true && pass.index === 2) {
                        this.enableControl(1);
                        this.enableControl(2);
                        this.enableControl(3);
                    } else {
                        this.enableControl(1);
                        this.enableControl(2);

                        this.disableControl(3);
                        this.disableControl(4);

                          }
                    break;
                case 3:
                    if (checked === true && pass.index === 3) {
                        this.enableControl(1);
                        this.enableControl(2);
                        this.enableControl(3);
                    } else {
                        this.enableControl(1);
                        this.enableControl(2);
                        this.enableControl(3);
                        this.disableControl(4);

                             }
                    break;

                case 4:
                    if (!checked && pass.index === 4) {
                        let ctrl2 = this.getControl(4);
                        this.form.get(ctrl2.value.key).setValue(100);
                        this.form.get(ctrl2.value.key).markAsDirty();
                        this.form.get(ctrl2.value.key).markAsTouched();
                    } else {
                        this.enableControl(4);
                    }
                    break;
            }
        });
    }

    toggleCheckBox(pass: ComponentGroupModel, checked: boolean): Promise<true> {
        return new Promise<true>((resolve, reject) => {
            if (pass.index < 5) {
                if (!checked && pass.index < this.passCount) {
                    for (var i = this.passCount; i > pass.index; i--) {
                        this.toggleCheckBox(
                            this.passState.find((item) => item.index === i),
                            false
                        );
                    }
                }

                if (checked) {
                    for (var i = 1; i < this.passCount; i++) {
                        const passCheck = this.passState.find((item) => item.index === i);
                        if (!passCheck.checked && i < pass.index) {
                            this.toggleCheckBox(passCheck, true);
                        }
                    }
                }
                pass.checked = checked;
            }
            if (pass.index == 4) {
                pass.checked = checked;
            }
        });
    }

    checkingValidators() {
        let lastIndex = this.lastIndex();
        switch (lastIndex) {
            case 1:
                let ctrlModel = this.getControl(1);
                this.form.get(ctrlModel.value.key).setValidators(Validators.required);
                this.form.get(ctrlModel.value.key).updateValueAndValidity();
                if (this.form.get(ctrlModel.value.key).value != null) {
                    if (this.form.get(ctrlModel.value.key).value <= 0) {
                        this.form.get(ctrlModel.value.key).setValidators(Validators.compose([MustValue]));
                        this.form.get(ctrlModel.value.key).updateValueAndValidity();
                    } else {
                        this.form.get(ctrlModel.value.key).setValidators(Validators.compose([Validators.max(100), Validators.min(100)]));
                        this.form.get(ctrlModel.value.key).updateValueAndValidity();
                    }
                }
                this.cd.markForCheck();
                break;
            case 2:
                let ctrlModel2 = this.getControl(2);
                let ctrlModel1 = this.getControl(1);
                let formControl1 = this.form.get(ctrlModel1.value.key);
                let formControl2 = this.form.get(ctrlModel2.value.key);

                this.form.get(ctrlModel1.value.key).clearValidators();
                this.form.get(ctrlModel1.value.key).setValidators([Validators.required, MustValue]);
                this.form.get(ctrlModel1.value.key).updateValueAndValidity();
                this.form.get(ctrlModel2.value.key).setValidators(Validators.required);
                this.form.get(ctrlModel2.value.key).updateValueAndValidity();
                if (formControl2.value != null) {
                    if (formControl2.value <= 0) {
                        this.form.get(ctrlModel2.value.key).setValidators([MustValue]);
                        this.form.get(ctrlModel2.value.key).updateValueAndValidity();
                    } else {
                        this.form.get(ctrlModel2.value.key).clearValidators();
                        this.form
                            .get(ctrlModel2.value.key)
                            .setValidators(
                                Validators.compose([
                                    Validators.required,
                                    Validators.max(100),
                                    Validators.min(100),
                                    MustValue,
                                    Compare(formControl1, formControl2),
                                ])
                            );
                        this.form.get(ctrlModel2.value.key).updateValueAndValidity();
                    }
                }
                break;

            case 3:
                let ctrl1 = this.getControl(1);
                let ctrl2 = this.getControl(2);
                let ctrl3 = this.getControl(3);
                let formControls1 = this.form.get(ctrl1.value.key);
                let formControls2 = this.form.get(ctrl2.value.key);
                let formControls3 = this.form.get(ctrl3.value.key);

                this.form.get(ctrl1.value.key).clearValidators();
                this.form.get(ctrl2.value.key).clearValidators();
                this.form.get(ctrl1.value.key).setValidators([Validators.required, MustValue]);
                this.form.get(ctrl1.value.key).updateValueAndValidity();
                this.form.get(ctrl2.value.key).setValidators([Validators.required, MustValue]);
                this.form.get(ctrl2.value.key).updateValueAndValidity();
                this.form.get(ctrl3.value.key).setValidators(Validators.required);
                this.form.get(ctrl3.value.key).updateValueAndValidity();
                if (formControls2.value != null) {
                    this.form.get(ctrl2.value.key).clearValidators();
                    formControls2.setValidators(Validators.compose([Validators.required, MustValue, Compare(formControls1, formControls2)]));
                }
                if (formControls3.value != null) {
                    if (formControls3.value <= 0) {
                        this.form.get(ctrl3.value.key).setValidators([MustValue]);
                        this.form.get(ctrl3.value.key).updateValueAndValidity();
                    } else {
                        this.form
                            .get(ctrl3.value.key)
                            .setValidators(Validators.compose([Validators.min(100), Validators.max(100), Compare(formControls2, formControls3)]));
                        this.form.get(ctrl3.value.key).updateValueAndValidity();
                    }
                }
                break;
        }
        this.form.updateValueAndValidity();
        this.cd.detectChanges();
    }

    lastIndex() {
        let index1 = -1;
        for (let i = 0; i < this.passState.length - 1; i++) {
            if (this.passState[i].checked === true) {
                index1 = this.passState[i].index;
            }
        }
        return index1;
    }

    removeValidators() {
        let ctrl1 = this.passState.find((item) => item.index === 1);
        let ctrl2 = this.passState.find((item) => item.index === 2);
        let ctrl3 = this.passState.find((item) => item.index === 3);
        this.form.get(ctrl1.value.key).clearValidators();
        this.form.get(ctrl2.value.key).clearValidators();
        this.form.get(ctrl3.value.key).clearValidators();
        this.form.updateValueAndValidity();
        this.cd.markForCheck();
    }

    getControl(i) {
        return this.passState.find((item) => item.checked === true && item.index === i);
    }
}
